import moment from 'moment'

export default {
  install (Vue) {
    Vue.filter('prefix', function (value, format) {
      if (!format) return value
      return format + value
    })
    Vue.filter('suffix', function (value, format) {
      if (!format) return value
      return value + format
    })
    Vue.filter('capitalize', function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    })
    Vue.filter('truncate', function (text, length) {
      if (text.length > length && text.split(' ').length > 1) {
        let string = text.substring(0, length)
        let splitText = string.split(' ')
        splitText.pop()
        return splitText.join(' ') + '...'
      } else {
        return text
      }
    })
    Vue.filter('moment', function (date, format = 'DD-MM-YYYY') {
      if (!date || date === undefined) {
        return ''
      }
      if (date && typeof date === 'object' && date.hasOwnProperty('date') && !(date instanceof Date)) {
        return date ? moment(date.date).format(format) : ''
      }
      return date ? moment(date).format(format) : ''
    })
  }
}
